module.exports = __webpack_public_path__ + "img/H5ui.d29734b1.png";